// extracted by mini-css-extract-plugin
module.exports = {"inline":"_3tpGN","container":"_2zc3c","noSpacing":"_1tytO","dotWrapper":"_3BUI_","background":"_1H4Oe","dot":"_3RveM","word":"wGKgv","number":"_3aRmc"};